module.exports = { "default": require("core-js/library/fn/reflect/delete-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/reflect/delete-property.js
// module id = 647
// module chunks = 1